/**
 * @author Johann Esneider Casallas Becerra
 * @Copyright (c) Infotrack. All rights reserved.
 */

import ModeloProducto from "Infotrack@Modelos/smartStock/gestionProducto";
import ModeloMaximosMinimos from "Infotrack@Modelos/smartStock/maximosMinimos";
import IFiltrosItem from "Infotrack@Modelos/smartStock/gestionProducto/entidades/filtrosItem";
import { IPaginador } from "@infotrack/presentacion-transversales/interfacesComunes";

export default class productoCM {
    private modeloProducto : ModeloProducto;

    constructor() {
        this.modeloProducto = new ModeloProducto();
    }

    public consultarListaProductoPrincipal = (filtros: IFiltrosItem) =>
  this.modeloProducto
    .consultarListaProductoPrincipal({ items: filtros })
    .then(({ data }) => data);

    public consultarListaItems = async (paginador: IPaginador, filtro: IFiltrosItem) => {
        const respuesta = await this.modeloProducto.consultarListaProductoPrincipal({
            items: filtro,
            paginador: paginador,
        });
      
        return respuesta.data;
    };
}

